import axios from "axios";

export default class LoginService {

	constructor() {
		this.url = '/clients-webservice';
	}

  login(user) {
			return axios.post(`${this.url}/login`, user);
  }

	sendResetPassword(email) {
		return axios.post(`${this.url}/login/operator/recover`, { email: email });
	}

	changePassword(token, changedPassword) {
		return axios.put(`${this.url}/login/operator/change-password`, { token: token, password: changedPassword });
	}
}



// WEBPACK FOOTER //
// ./src/services/LoginService.js